import React from "react";
import { TableHeadersType } from "../../../constant/tableHeadersConstants/tableHeadersType";
import { commentIcon, tableEditIcon } from "../../../assets/images";
import { formatDate } from "../../../utils/commonFunctions";
import { Button } from "reactstrap";

type AppProps = {
  tableHeader: [] | TableHeadersType[];
  schedulingUserViewListing: any[];
  handleToggleEstimateModal: () => void;
  handleEstimate?: (data: any) => void;
  handleToggleCommentModal?: () => void;
  handleCommentSection?: (data: any) => void;
};
const SchedulingUserViewListTable = ({
  tableHeader,
  schedulingUserViewListing,
  handleToggleEstimateModal,
  handleToggleCommentModal,
  handleEstimate,
  handleCommentSection,
}: AppProps) => {
  const statusApprovalPendingTypeStyle = () => {
    return {
      padding: "4px 13px 4px 13px",
      color: "#f3a119",
      background: "#faedd8",
      borderRadius: "16px",
      width: "20px",
    };
  };

  const statusReEstimateTypeStyle = () => {
    return {
      padding: "4px 13px 4px 13px",
      color: "#2d8589",
      background: "#d4edf0",
      borderRadius: "16px",
      width: "20px",
    };
  };
  const approvedEstimateTypeStyle = () => {
    return {
      padding: "4px 13px 4px 13px",
      color: "#82b01f",
      background: "#e7f0d4",
      borderRadius: "16px",
      width: "20px",
    };
  };

  const statusUnScheduledTypeStyle = () => {
    return {
      padding: "4px 13px 4px 13px",
      color: "#262a44",
      background: "#e2e4ed",
      borderRadius: "16px",
      width: "20px",
    };
  };
  const blank = () => {
    return {};
  };
  return (
    <>
      {schedulingUserViewListing?.length > 0 &&
        schedulingUserViewListing?.map((schedulingUserViewListingData: any) => {
          return (
            <tr className="text-left">
              {tableHeader?.length > 0 &&
                tableHeader?.map((header: TableHeadersType) => {
                  if (header?.value == "job_type") {
                    return (
                      <td className="text-left">
                        <div style={{display:'flex' , flexDirection:'column' , gap:'10px'}}> 
                          <div>
                        {/* {schedulingUserViewListingData?.job_type} */}
                        {(schedulingUserViewListingData?.job_id ?`${schedulingUserViewListingData?.job_id}_`:'')+
                        schedulingUserViewListingData?.job_type +
                          `_` +
                          formatDate(
                            schedulingUserViewListingData?.period_ended
                          )}
                          </div>
                          { schedulingUserViewListingData?.shared_job && schedulingUserViewListingData?.schedule_status===3?
                          <span style={{color:'#6e7491' , backgroundColor:"#eef1f4" , borderRadius: "16px" ,  width: "95px" ,   padding: "4px 8px"}}>{schedulingUserViewListingData?.shared_job ? "Shared Job" :''}</span>:''}
                          </div>
                      </td>
                    );
                  } else if (header?.value == "job_description") {
                    return (
                      <td className="text-left">
                        {schedulingUserViewListingData.job_description}
                      </td>
                    );
                  }
                    else if (header?.value == "client") {
                    return (
                      <td className="text-left">
                        {`${schedulingUserViewListingData?.client_name} (${schedulingUserViewListingData?.client_code})`}
                      </td>
                    );
                  }
                  else if (header?.value == "target_start_date") {
                    // const formattedStartDate = formatDate(
                    //   schedulingUserViewListingData?.target_start_date
                    // );

                    return (
                      <td className="text-left" style={{ minWidth: "50px" }}>
                        {/* {schedulingUserViewListingData?.target_start_date}
                         */}
                        {schedulingUserViewListingData?.target_start_date
                          ? formatDate(
                              schedulingUserViewListingData?.target_start_date
                            )
                          : "--/--"}
                      </td>
                    );
                  } else if (header?.value == "target_end_date") {
                    const formattedDate = formatDate(
                      schedulingUserViewListingData?.target_end_date
                    );

                    return (
                      <td className="text-left" style={{ minWidth: "50px" }}>
                        {/* {schedulingUserViewListingData?.target_end_date}
                         */}
                        {schedulingUserViewListingData?.target_end_date
                          ? formattedDate
                          : "--/--"}
                      </td>
                    );
                    //
                  } else if (header?.value == "total_hours") {
                    return (
                      <td className="text-left">
                        {schedulingUserViewListingData.total_hours}
                      </td>
                    );
                  } else if (header?.value == "schedule_status") {
                    return (
                      <td className="text-left">
                        <span
                          style={
                            schedulingUserViewListingData?.schedule_status === 1
                              ? statusApprovalPendingTypeStyle()
                              : schedulingUserViewListingData?.schedule_status ===
                                2
                              ? statusReEstimateTypeStyle()
                              : schedulingUserViewListingData?.schedule_status ===
                                0
                              ? statusUnScheduledTypeStyle()
                              : schedulingUserViewListingData?.schedule_status ===
                                3
                              ? approvedEstimateTypeStyle()
                              : blank()
                          }
                        >
                          {schedulingUserViewListingData?.schedule_status === 1
                            ? "Approval Pending"
                            : schedulingUserViewListingData?.schedule_status ===
                              2
                            ? "Re-Estimate"
                            : schedulingUserViewListingData?.schedule_status ===
                              3
                            ? "Approved"
                            : schedulingUserViewListingData?.schedule_status ===
                              0
                            ? "Unscheduled"
                            : ""}
                        </span>
                      </td>
                    );
                  }

                
                else if (header?.value == "action") {
                    return (
              <td style={{ minWidth: "142px", textAlign: "start" }}>
                <div>
                  {
                    <span
                      style={{ display: "flex", alignItems: "center" }}
                      className=" pointer"
                      // onClick={()=>handleEditLeadModule(LeadModuleListData?.client_code)}
                    >
                    
                      <div>
                        <Button
                          outline
                          color="danger"
                          className="ouline-button-hover"
                          disabled={
                            schedulingUserViewListingData?.schedule_status === 1
                          }
                          onClick={() => {
                            handleToggleEstimateModal?.();
                            handleEstimate?.(schedulingUserViewListingData);
                          }}
                        >
                          {" "}
                          {schedulingUserViewListingData?.schedule_status === 0
                            ? "  + Estimate"
                            : "Re Estimate"}
                        </Button>
                      </div>
                      {/* FUTURE USE */}
                      {/* <div>
                        {schedulingUserViewListingData?.schedule_status === 2 ||
                        schedulingUserViewListingData?.schedule_status === 1 ||
                        schedulingUserViewListingData?.schedule_status === 3 ? (
                          <img
                            className="ml-2"
                            src={commentIcon}
                            alt="comment-icon"
                            onClick={() => {
                              handleToggleCommentModal?.();
                              handleCommentSection?.(
                                schedulingUserViewListingData
                              );
                            }}
                          />
                        ) : (
                          ""
                        )}
                      </div> */}
                    </span>
                  }
                </div>
              </td>
                    )}
                    return (
                      <td>{schedulingUserViewListingData?.header?.value}</td>
                    );
                  })}
            </tr>
          );
        })}
    </>
  );
};

export default SchedulingUserViewListTable;
